import React, { Fragment, useState } from 'react'
import { useNavigate, useSearchParams } from 'react-router-dom';
import { getSortedData } from '../../../../../components/commonClass/DataSorting';

const HotelSearchList = ({ hotelList, setHotelList }:any) => {
    const [searchParams, setSearchParams] = useSearchParams();
    const navigate = useNavigate();

    const navigateDetailsScreen = (code:any) => {
        const urlParams = new URLSearchParams(searchParams);
        urlParams.set('HotelCodes', code);

        const urlPartg = `/hotel/details`
        const newSearch = `?${urlParams?.toString()}`;
        navigate({ pathname: urlPartg, search: newSearch });
    }

    const [selectedSorting, setSelectedSorting] = useState('Rating');
    const [sortOrder, setSortOrder] = useState({
        isPriceAscending: false,
        isRatingAscending: true,
    })

    const handleSortingData = (name:any, column:any) => {
        setSelectedSorting(name);
        const copy = hotelList?.slice();

        const isAscending = name === 'Price' ? sortOrder?.isPriceAscending : sortOrder?.isRatingAscending;
        const sortedList = getSortedData(copy, isAscending, column, "number");

        setHotelList(sortedList);

        setSortOrder((prev) => ({
            ...prev,
            isPriceAscending: name === 'Price' ? !prev?.isPriceAscending : prev?.isPriceAscending,
            isRatingAscending: name === 'Rating' ? !prev?.isRatingAscending : prev?.isRatingAscending
        }))
    }

    return (
        <div className="detailContainer">

            {
                hotelList !== null ?
                    hotelList?.length > 0 ?
                        <Fragment>
                            <div className="listShorting">
                                <ul>
                                    <li
                                        onClick={(e) => handleSortingData('Price', 'lowestPriceWithMarkup')}
                                        className={`cursor_pointer ${selectedSorting === 'Price' ? 'active' : ''}`}
                                    >
                                        Price
                                        <span className='ms-2'>
                                            <i className={`fa-solid ${!sortOrder?.isPriceAscending ? 'fa-arrow-down' : 'fa-arrow-up'}`}></i>
                                        </span>
                                    </li>
                                    <li
                                        onClick={(e) => handleSortingData('Rating', 'hotelDetails?.[0]?.hotelRating')}
                                        className={`cursor_pointer ${(selectedSorting === 'Rating') ? 'active' : ''}`}
                                    >
                                        Rating
                                        <span className='ms-2'>
                                            <i className={`fa-solid ${!sortOrder?.isRatingAscending ? 'fa-arrow-down' : 'fa-arrow-up'}`}></i>
                                        </span>
                                    </li>
                                </ul>
                            </div>
                            {
                                hotelList?.map((hotel:any) => (
                                    <div className="row hotelsList" key={hotel?.hotelCode}>
                                        <div className="col-lg-3 col-md-4 col-sm-3 hotelImg">
                                            <img
                                                src={hotel?.hotelDetails?.[0]?.image ? hotel?.hotelDetails?.[0]?.image : ''}
                                                onError={(e:any) => e.target.src = require("../../../../../assets/img/no-image.png")}
                                                loading="lazy" alt="hotel Holidays"
                                            />
                                        </div>
                                        <div className="col-xl-7 col-lg-6 col-md-6 col-sm-12 dashed">
                                            <div className="detail">
                                                <h4 className="placename">
                                                    {hotel?.hotelDetails?.[0]?.hotelName}
                                                </h4>
                                                <div className="rating mb-2">
                                                    {new Array(hotel?.hotelDetails?.[0]?.hotelRating).fill(hotel?.hotelDetails?.[0]?.hotelRating).map((star, index) => (
                                                        <i className="fa-solid fa-star" key={index}></i>
                                                    ))}
                                                </div>
                                                <div className="hotelLocation"><i className="fa-solid fa-location-dot"></i>
                                                    {hotel?.hotelDetails?.[0]?.cityName}
                                                </div>
                                            </div>
                                            <div className="amenities">
                                                <ul>
                                                    {hotel?.hotelDetails?.[0]?.hotelFacilities?.length > 0 && hotel?.hotelDetails?.[0]?.hotelFacilities?.slice(0, 8)?.map((amenity:any, index:any) => (
                                                        <li key={amenity + index}>{amenity}</li>
                                                    ))}
                                                </ul>
                                            </div>
                                        </div>

                                        <div className="col-xl-2 col-lg-3 col-md-2 col-sm-12">
                                            <div className="priceBox">
                                                {/* <p className="roomSold">1 room left</p> */}
                                                <div className="price">
                                                    {/* <p>28% off <span>₹ 2500</span></p> */}

                                                    <h5><span>₹ {hotel?.lowestPriceWithMarkup}</span></h5>
                                                    {/* <p>+₹{hotel?.tax}&nbsp;taxes&nbsp;&&nbsp;fees</p> */}
                                                </div>
                                                <button type='button' className="btn booknow" onClick={() => navigateDetailsScreen(hotel?.hotelCode)}>Book Now</button>
                                            </div>
                                        </div>
                                    </div>
                                ))
                            }
                        </Fragment> :
                        <div className='py-3 text-center text-danger fs-3'>No Records Found</div>
                    :
                    <></>
            }

            <div id="tripSlideOverlay" className=""></div>
        </div>
    )

}

export default HotelSearchList